var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMethod(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 240,
    height: 280,
    viewBox: "0 0 240 280",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1148_1865)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.8554 50V43.7H17.8064V44.798H14.9534V46.076H17.2169V47.174H14.9534V48.902H17.8064V50H13.8554ZM20.9318 50L18.6458 43.7H19.8113L21.6338 48.7175L23.4608 43.7H24.6218L22.3358 50H20.9318ZM25.4306 50V43.7H29.3816V44.798H26.5286V46.076H28.7921V47.174H26.5286V48.902H29.3816V50H25.4306ZM30.3964 50V43.7H32.8129C33.1549 43.7 33.4639 43.7855 33.7399 43.9565C34.0159 44.1275 34.2349 44.357 34.3969 44.645C34.5589 44.93 34.6399 45.2465 34.6399 45.5945C34.6399 45.8795 34.5874 46.142 34.4824 46.382C34.3804 46.619 34.2364 46.8245 34.0504 46.9985C33.8674 47.1725 33.6559 47.3045 33.4159 47.3945L34.9234 50H33.6589L32.2009 47.4935H31.4944V50H30.3964ZM31.4944 46.3955H32.6869C32.8429 46.3955 32.9854 46.3565 33.1144 46.2785C33.2434 46.2005 33.3469 46.0955 33.4249 45.9635C33.5029 45.8315 33.5419 45.6845 33.5419 45.5225C33.5419 45.3575 33.5029 45.209 33.4249 45.077C33.3469 44.945 33.2434 44.84 33.1144 44.762C32.9854 44.684 32.8429 44.645 32.6869 44.645H31.4944V46.3955ZM39.1617 43.7H40.4577L38.2932 47.1605V50H37.1952V47.1605L35.0307 43.7H36.3267L37.7442 45.9635L39.1617 43.7ZM46.0385 43.7V44.798H44.1125V50H43.0145V44.798H41.0885V43.7H46.0385ZM50.6455 43.7H51.7435V50H50.6455V47.174H48.0355V50H46.9375V43.7H48.0355V46.076H50.6455V43.7ZM52.9611 50V43.7H54.0591V50H52.9611ZM55.2783 50V43.7H56.4663L59.1258 48.0155V43.7H60.2238V50H59.0403L56.3763 45.6845V50H55.2783ZM64.2236 50.117C63.7856 50.117 63.3776 50.0315 62.9996 49.8605C62.6246 49.6895 62.2976 49.454 62.0186 49.154C61.7396 48.851 61.5206 48.503 61.3616 48.11C61.2056 47.714 61.1276 47.291 61.1276 46.841C61.1276 46.367 61.2116 45.932 61.3796 45.536C61.5506 45.14 61.7831 44.7965 62.0771 44.5055C62.3711 44.2145 62.7041 43.9895 63.0761 43.8305C63.4511 43.6715 63.8411 43.592 64.2461 43.592C64.6991 43.592 65.1386 43.6985 65.5646 43.9115C65.9936 44.1215 66.3716 44.447 66.6986 44.888L65.7176 45.4145C65.5166 45.1685 65.2856 44.9855 65.0246 44.8655C64.7666 44.7425 64.5026 44.681 64.2326 44.681C63.9686 44.681 63.7151 44.735 63.4721 44.843C63.2321 44.951 63.0176 45.104 62.8286 45.302C62.6426 45.497 62.4956 45.728 62.3876 45.995C62.2796 46.259 62.2256 46.5485 62.2256 46.8635C62.2256 47.1605 62.2781 47.441 62.3831 47.705C62.4881 47.966 62.6321 48.1955 62.8151 48.3935C63.0011 48.5885 63.2156 48.7415 63.4586 48.8525C63.7016 48.9635 63.9626 49.019 64.2416 49.019C64.4276 49.019 64.6091 48.9905 64.7861 48.9335C64.9661 48.8735 65.1341 48.788 65.2901 48.677C65.4491 48.566 65.5901 48.431 65.7131 48.272C65.8391 48.113 65.9441 47.933 66.0281 47.732H64.8806V46.7735H67.3196C67.3316 47.2325 67.2596 47.663 67.1036 48.065C66.9476 48.467 66.7271 48.8225 66.4421 49.1315C66.1571 49.4405 65.8256 49.682 65.4476 49.856C65.0696 50.03 64.6616 50.117 64.2236 50.117Z",
    fill: "#9A9A9A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35 190C62.6142 190 85 167.614 85 140C85 112.386 62.6142 90 35 90C7.38576 90 -15 112.386 -15 140C-15 167.614 7.38576 190 35 190Z",
    fill: "url(#paint0_radial_1148_1865)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35 146C38.3137 146 41 143.314 41 140C41 136.686 38.3137 134 35 134C31.6863 134 29 136.686 29 140C29 143.314 31.6863 146 35 146Z",
    fill: "#5A5A5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35 142.5C36.3807 142.5 37.5 141.381 37.5 140C37.5 138.619 36.3807 137.5 35 137.5C33.6193 137.5 32.5 138.619 32.5 140C32.5 141.381 33.6193 142.5 35 142.5Z",
    fill: "#9A9A9A"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M35 110C42.9565 110 50.5871 113.161 56.2132 118.787C61.8393 124.413 65 132.044 65 140C65 147.956 61.8393 155.587 56.2132 161.213C50.5871 166.839 42.9565 170 35 170",
    stroke: "#5A5A5A",
    strokeWidth: 1.4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.55,
    d: "M35 98C46.1391 98 56.822 102.425 64.6985 110.302C72.575 118.178 77 128.861 77 140C77 151.139 72.575 161.822 64.6985 169.698C56.822 177.575 46.1391 182 35 182",
    stroke: "#5A5A5A",
    strokeWidth: 1.3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M35 86C49.3217 86 63.0568 91.6893 73.1838 101.816C83.3107 111.943 89 125.678 89 140C89 154.322 83.3107 168.057 73.1838 178.184C63.0568 188.311 49.3217 194 35 194",
    stroke: "#5A5A5A",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M35 74C52.5043 74 69.2916 80.9536 81.669 93.331C94.0464 105.708 101 122.496 101 140C101 157.504 94.0464 174.292 81.669 186.669C69.2916 199.046 52.5043 206 35 206",
    stroke: "#5A5A5A",
    strokeWidth: 1.1,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M117 55H115V110H117V55Z",
    fill: "white",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M117 130H115V150H117V130Z",
    fill: "white",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M117 170H115V225H117V170Z",
    fill: "white",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.55,
    d: "M116 125C118.761 125 121 122.761 121 120C121 117.239 118.761 115 116 115C113.239 115 111 117.239 111 120C111 122.761 113.239 125 116 125Z",
    fill: "#FF6B1A"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.55,
    d: "M116 165C118.761 165 121 162.761 121 160C121 157.239 118.761 155 116 155C113.239 155 111 157.239 111 160C111 162.761 113.239 165 116 165Z",
    fill: "#FF6B1A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116 122C117.105 122 118 121.105 118 120C118 118.895 117.105 118 116 118C114.895 118 114 118.895 114 120C114 121.105 114.895 122 116 122Z",
    fill: "#FF6B1A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116 162C117.105 162 118 161.105 118 160C118 158.895 117.105 158 116 158C114.895 158 114 158.895 114 160C114 161.105 114.895 162 116 162Z",
    fill: "#FF6B1A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.937 49V44.1H108.832V44.954H106.791V45.948H108.496V46.802H106.791V49H105.937ZM109.446 49V44.1H110.3V49H109.446ZM111.249 49V44.1H112.103V48.146H114.143V49H111.249ZM118.096 44.1V44.954H116.598V49H115.744V44.954H114.246V44.1H118.096ZM118.795 49V44.1H121.868V44.954H119.649V45.948H121.41V46.802H119.649V48.146H121.868V49H118.795ZM122.658 49V44.1H124.537C124.803 44.1 125.044 44.1665 125.258 44.2995C125.473 44.4325 125.643 44.611 125.769 44.835C125.895 45.0567 125.958 45.3028 125.958 45.5735C125.958 45.7952 125.917 45.9993 125.836 46.186C125.756 46.3703 125.644 46.5302 125.5 46.6655C125.357 46.8008 125.193 46.9035 125.006 46.9735L126.179 49H125.195L124.061 47.0505H123.512V49H122.658ZM123.512 46.1965H124.439C124.561 46.1965 124.671 46.1662 124.772 46.1055C124.872 46.0448 124.953 45.9632 125.013 45.8605C125.074 45.7578 125.104 45.6435 125.104 45.5175C125.104 45.3892 125.074 45.2737 125.013 45.171C124.953 45.0683 124.872 44.9867 124.772 44.926C124.671 44.8653 124.561 44.835 124.439 44.835H123.512V46.1965Z",
    fill: "#9A9A9A"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M116 120C135.333 120 151.667 125 165 135C175 145 185 160 195 180",
    stroke: "#FF6B1A",
    strokeLinecap: "round",
    strokeDasharray: "2 3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M116 120C138.667 118.666 158.333 122 175 130C188.333 140 200 153.333 210 170",
    stroke: "#FF6B1A",
    strokeLinecap: "round",
    strokeDasharray: "2 3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M116 160C135.333 160 151.667 155 165 145C175 135 185 120 195 100",
    stroke: "#FF6B1A",
    strokeLinecap: "round",
    strokeDasharray: "2 3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M116 160C138.667 161.333 158.333 158 175 150C188.333 140 200 126.667 210 110",
    stroke: "#FF6B1A",
    strokeLinecap: "round",
    strokeDasharray: "2 3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200 195C230.376 195 255 170.376 255 140C255 109.624 230.376 85 200 85C169.624 85 145 109.624 145 140C145 170.376 169.624 195 200 195Z",
    fill: "url(#paint1_radial_1148_1865)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209 135H186C185.448 135 185 135.448 185 136V140C185 140.552 185.448 141 186 141H209C209.552 141 210 140.552 210 140V136C210 135.448 209.552 135 209 135Z",
    fill: "#FF6B1A"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M207 115H188C187.448 115 187 115.448 187 116V118C187 118.552 187.448 119 188 119H207C207.552 119 208 118.552 208 118V116C208 115.448 207.552 115 207 115Z",
    fill: "#FF6B1A"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M207 156H188C187.448 156 187 156.448 187 157V159C187 159.552 187.448 160 188 160H207C207.552 160 208 159.552 208 159V157C208 156.448 207.552 156 207 156Z",
    fill: "#FF6B1A"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.45,
    d: "M205 98H190C189.448 98 189 98.4477 189 99V100C189 100.552 189.448 101 190 101H205C205.552 101 206 100.552 206 100V99C206 98.4477 205.552 98 205 98Z",
    fill: "#FF6B1A"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.45,
    d: "M205 175H190C189.448 175 189 175.448 189 176V177C189 177.552 189.448 178 190 178H205C205.552 178 206 177.552 206 177V176C206 175.448 205.552 175 205 175Z",
    fill: "#FF6B1A"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M203 84H192C191.448 84 191 84.4477 191 85C191 85.5523 191.448 86 192 86H203C203.552 86 204 85.5523 204 85C204 84.4477 203.552 84 203 84Z",
    fill: "#FF6B1A"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M203 190H192C191.448 190 191 190.448 191 191C191 191.552 191.448 192 192 192H203C203.552 192 204 191.552 204 191C204 190.448 203.552 190 203 190Z",
    fill: "#FF6B1A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.133 213.7H179.398L181.688 220H180.523L180.118 218.884H177.418L177.013 220H175.847L178.133 213.7ZM177.818 217.786H179.713L178.763 215.189L177.818 217.786ZM186.493 213.7V214.798H184.567V220H183.469V214.798H181.543V213.7H186.493ZM192.162 213.7V214.798H190.236V220H189.138V214.798H187.212V213.7H192.162ZM193.061 220V213.7H197.012V214.798H194.159V216.076H196.422V217.174H194.159V218.902H197.012V220H193.061ZM198.026 220V213.7H199.214L201.874 218.015V213.7H202.972V220H201.788L199.124 215.684V220H198.026ZM208.826 213.7V214.798H206.9V220H205.802V214.798H203.876V213.7H208.826ZM209.86 220V213.7H210.958V220H209.86ZM215.102 220.117C214.676 220.117 214.275 220.033 213.9 219.865C213.525 219.694 213.195 219.458 212.91 219.158C212.625 218.858 212.402 218.512 212.24 218.119C212.078 217.723 211.997 217.3 211.997 216.85C211.997 216.4 212.078 215.978 212.24 215.585C212.402 215.189 212.625 214.841 212.91 214.541C213.195 214.241 213.525 214.007 213.9 213.839C214.275 213.668 214.676 213.583 215.102 213.583C215.531 213.583 215.933 213.668 216.308 213.839C216.683 214.007 217.013 214.241 217.298 214.541C217.583 214.841 217.805 215.189 217.964 215.585C218.126 215.978 218.207 216.4 218.207 216.85C218.207 217.3 218.126 217.723 217.964 218.119C217.805 218.512 217.583 218.858 217.298 219.158C217.013 219.458 216.683 219.694 216.308 219.865C215.933 220.033 215.531 220.117 215.102 220.117ZM215.102 219.019C215.378 219.019 215.637 218.962 215.88 218.848C216.123 218.734 216.336 218.578 216.519 218.38C216.705 218.179 216.849 217.948 216.951 217.687C217.056 217.426 217.109 217.147 217.109 216.85C217.109 216.553 217.056 216.274 216.951 216.013C216.846 215.749 216.701 215.518 216.515 215.32C216.332 215.122 216.119 214.966 215.876 214.852C215.636 214.738 215.378 214.681 215.102 214.681C214.826 214.681 214.566 214.738 214.323 214.852C214.08 214.966 213.866 215.123 213.68 215.324C213.497 215.522 213.353 215.752 213.248 216.013C213.146 216.274 213.095 216.553 213.095 216.85C213.095 217.15 213.147 217.43 213.252 217.691C213.357 217.952 213.501 218.183 213.684 218.384C213.87 218.582 214.083 218.738 214.323 218.852C214.566 218.963 214.826 219.019 215.102 219.019ZM219.023 220V213.7H220.211L222.871 218.015V213.7H223.969V220H222.785L220.121 215.684V220H219.023Z",
    fill: "#FF6B1A"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.85,
    d: "M218 138L224 135V141L218 138Z",
    fill: "#FF6B1A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_1148_1865",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(35 140) scale(50)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3A3A3A",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3A3A3A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_1148_1865",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(200 140) scale(66)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6B1A",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6B1A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1148_1865"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 240,
    height: 280,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMethod);
export default __webpack_public_path__ + "static/media/method.9f06f6b06e11dad8c6a952da61abf20e.svg";
export { ForwardRef as ReactComponent };